export const ADULT_MEASUREMENTS = {
  front: {
    legendLeft: {
      title: "3”",
      description: "XS-XL"
    },
    legendRight: {
      title: "4”",
      description: "2XL+"
    }
  },
  back: {
    legendLeft: {
      title: "4”",
      description: "XS-XL"
    },
    legendRight: {
      title: "5”",
      description: "2XL+"
    }
  },
  front_left_chest: {
    legendLeft: {
      title: "3”",
      description: "XS-XL"
    },
    legendRight: {
      title: "4”",
      description: "2XL+"
    }
  }
};

export const YOUTH_MEASUREMENTS = {
  front: {
    legendLeft: {
      title: "2”",
      description: "XS-XL"
    }
  },
  back: {
    legendLeft: {
      title: "3”",
      description: "XS-XL"
    }
  },
  front_left_chest: {
    legendLeft: {
      title: "2”",
      description: "XS-XL"
    }
  }
};

export default {};
